module.exports = require('buffer').Buffer;



//////////////////
// WEBPACK FOOTER
// ./build/temp/library/webpack/BFSBuffer.js
// module id = 7
// module chunks = 0